import { memo } from "react";

import type { HotelForReOnboardingRequestQueryQuery } from "@/lib/gql/__generated__/graphql";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog/dialog";

import { useInitialized } from "./model/use-case";
import { ReOnboardingRequestForm } from "./ui";

type Props = {
	onOpenChange: (open: boolean) => void;

	data: HotelForReOnboardingRequestQueryQuery;
};

export const ReOnboardingRequestDialogPresenter = memo(({ onOpenChange, data }: Props) => {
	const { viewModel, onSetViewModel, onSendReOnboardingRequest } = useInitialized({ data });

	return (
		<Dialog open onOpenChange={onOpenChange}>
			<DialogContent className="md:max-w-3xl">
				<DialogHeader>
					<DialogTitle>CHILLNNの使い方をもう一度教えてもらう</DialogTitle>
				</DialogHeader>

				<div className="border-b border-zinc-300" />

				<div className="whitespace-pre-wrap text-sm">
					{`自由記入欄に現在の状況などをお書きください。\nご入力いただいたメールアドレス宛に担当者からご連絡を差し上げます。\nオンライン面談などで丁寧にサポートを行わせていただきます。`}
				</div>

				<div className="mt-3">
					<ReOnboardingRequestForm
						viewModel={viewModel}
						onSetViewModel={onSetViewModel}
						onSendReOnboardingRequest={onSendReOnboardingRequest}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
});
